export const CREATE_BACKGROUND_PLACEHOLDER = 'CREATE_BACKGROUND_PLACEHOLDER';
export const LOAD_BACKGROUND_PLACEHOLDERS_BY_BOOK_ID = 'LOAD_BACKGROUND_PLACEHOLDERS_BY_BOOK_ID';



// WEBPACK FOOTER //
// ./src/redux/action-types/entities/backgroundPlaceholders.js